export const TOTEMS_STATES_LABELS = {
    Regular: 'Régulier',
    Rollout: 'Actif',
    Archived: 'Archivé',
};
